import { Link } from 'react-router-dom'
import SectionLabel from './SectionLabel'
import BlogCard from './BlogCard'
import { posts } from '../data/blog'

export default function BlogPreview() {
  const previews = posts.slice(0, 3)

  return (
    <section className="section" style={{ background: 'var(--white)' }}>
      <SectionLabel>Trekking Insights</SectionLabel>
      <h2 className="section-title">Preparation starts here.</h2>
      <p className="section-sub">
        Permit breakdowns, gear lists, and honest trail advice from a decade of guiding.
      </p>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: '24px', 
        marginTop: '20px' 
      }}>
        {previews.map(p => (
          <BlogCard key={p.slug} post={p} />
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '32px' }}>
        <Link to="/blog" className="btn btn-slate">View All Articles</Link>
      </div>
    </section>
  )
}
